import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";function ownKeys(object, enumerableOnly) {var keys = _Object$keys(object);if (_Object$getOwnPropertySymbols) {var symbols = _Object$getOwnPropertySymbols(object);enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {return _Object$getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));});}return target;}import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";import React from 'react';
import Table from "../Table";

import { PRODUCT_LINES_CONTENT_MAP } from "../../utils/ProductLinesHelper";
import clsx from 'clsx';
import ComparisonTableBody from "./ComparisonTableBody";
import ComparisonTableHeader from "./ComparisonTableHeader";
import { filterByPlId, getTotalColumnsAmount } from "./utils";
import { createStyles } from "./styles";

var ComparisonTable = function ComparisonTable(_ref)















{var cartItems = _ref.cartItems,portfolios = _ref.portfolios,marketingTags = _ref.marketingTags,productLineId = _ref.productLineId,loading = _ref.loading,productLineAttributes = _ref.productLineAttributes,addButtonTitle = _ref.addButtonTitle,removeButtonTitle = _ref.removeButtonTitle,onAddToProposal = _ref.onAddToProposal,onRemoveFromProposal = _ref.onRemoveFromProposal,onConfigure = _ref.onConfigure,lastUpdateBcShortName = _ref.lastUpdateBcShortName,containerStyles = _ref.containerStyles,loaderInPortfolioId = _ref.loaderInPortfolioId,_ref$highlightBCAndCo = _ref.highlightBCAndConfigurePortfolio,highlightBCAndConfigurePortfolio = _ref$highlightBCAndCo === void 0 ? false : _ref$highlightBCAndCo;
  // Defines total width. This will be multiplied by 34 (1 column width)
  // It includes products and variants amount
  var columnsAmount = getTotalColumnsAmount(portfolios);

  // Make columns for portfolio with 1 product and 1 variant wider
  var showWideColumns =
  portfolios.every(function (_ref2) {var products = _ref2.products;
    return products.every(function (_ref3) {var bcDependentData = _ref3.bcDependentData;
      return _Object$keys(bcDependentData).length === 1 && products.length === 1;
    });
  }) && portfolios.length < 3;

  var classes = createStyles({ columnsAmount: columnsAmount, showWideColumns: showWideColumns });

  // Filter by product line id
  var filteredPortfolios = filterByPlId(portfolios, productLineId);
  // Sort products in portfolio by imProductId
  var sortedProductsInPortfolioById = _mapInstanceProperty(filteredPortfolios).call(filteredPortfolios, function (portfolio) {var _context;
    var sortedProducts = _sortInstanceProperty(_context = portfolio.products).call(_context, function (a, b) {return (
        a.imProductId > b.imProductId ? 1 : -1);});

    return _objectSpread(_objectSpread({}, portfolio), {}, { products: sortedProducts });
  });

  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.tableContainer, containerStyles) }, /*#__PURE__*/
    React.createElement(Table, { className: classes.comparisonTable }, /*#__PURE__*/
    React.createElement(ComparisonTableHeader, {
      cartItems: cartItems,
      lastUpdateBcShortName: lastUpdateBcShortName,
      productLineId: productLineId,
      portfolios: sortedProductsInPortfolioById,
      addButtonTitle: addButtonTitle,
      removeButtonTitle: removeButtonTitle,
      onAddToProposal: onAddToProposal,
      onRemoveFromProposal: onRemoveFromProposal,
      onConfigure: onConfigure,
      showWideColumns: showWideColumns,
      loaderInPortfolioId: loaderInPortfolioId,
      highlightBCAndConfigurePortfolio: highlightBCAndConfigurePortfolio }), /*#__PURE__*/

    React.createElement(ComparisonTableBody, {
      columnsAmount: columnsAmount,
      cartItems: cartItems,
      productLine: PRODUCT_LINES_CONTENT_MAP[productLineId].label,
      portfolios: sortedProductsInPortfolioById,
      loading: loading,
      productLineAttributes: productLineAttributes,
      marketingTags: marketingTags,
      changeBgStyle: !!(addButtonTitle && removeButtonTitle),
      showWideColumns: showWideColumns,
      highlightBCAndConfigurePortfolio: highlightBCAndConfigurePortfolio }))));




};

export default ComparisonTable;
//# sourceMappingURL=index.js.map